<template>
    <v-dialog
        v-model="dialog"
        :max-width="maxWidth"
        :style="{ zIndex: zIndex }"
        @keydown.esc="cancel"
        v-if="customer"
    >
        <v-card>
            <v-card-title class="headline">
                {{ $t('actions.customer.cancellationRequisition.title') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <p>
                    <strong
                        >{{
                            $t(
                                'resources.cancellationRequisition.attributes.customer',
                            )
                        }}: </strong
                    >{{ customer.legal_name || customer.trade_name }}
                </p>
                <p>
                    <strong
                        >{{
                            $t(
                                'resources.cancellationRequisition.attributes.created_at',
                            )
                        }}:
                    </strong>
                    {{ customer.cancellationRequisition.formattedCreatedAt }}
                </p>
                <p>
                    <strong
                        >{{
                            $t(
                                'resources.cancellationRequisition.attributes.reason',
                            )
                        }}:
                    </strong>
                    {{ customer.cancellationRequisition.reason }}
                </p>
                <v-text-field
                    :label="
                        $t('resources.cancellationRequisition.attributes.note')
                    "
                    v-model="customer.cancellationRequisition.note"
                >
                </v-text-field>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    class="col"
                    color="green darken-1"
                    text
                    @click.native="cancel"
                >
                    {{ $t('actions.customer.cancellationRequisition.decline') }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="red darken-1"
                    text
                    @click.native="agree"
                >
                    {{ $t('actions.customer.cancellationRequisition.approve') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data: () => ({
        customer: null,
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        zIndex: 200,
        maxWidth: 500,
        btnConfirmColor: null,
    }),

    methods: {
        open(customer, confirmColor) {
            this.dialog = true
            this.customer = customer
            this.btnConfirmColor = confirmColor || this.confirmColor
        },
        agree() {
            this.customer.cancellationRequisition.retained = false
            this.customer.cancellationRequisition.save()

            this.$bus.$emit(
                'notify',
                'success',
                'Cancelamento efetuado com sucesso!',
            )

            this.$emit('modelChanged', this.customer)
            this.dialog = false
        },
        cancel() {
            this.customer.cancellationRequisition.retained = true
            this.customer.cancellationRequisition.save()

            this.$bus.$emit(
                'notify',
                'success',
                'Retenção efetuado com sucesso!',
            )
            this.$emit('modelChanged', this.customer)
            this.dialog = false
        },
    },

    created() {
        this.btnConfirmColor = this.confirmColor
    },
}
</script>
